import { USER_ACCESS } from "@/constants";
import { useUser } from "./useUser";

export const useCanManageUsers = () => {
  const { data: currentUser } = useUser();

  return currentUser?.ok
    ? currentUser.data.is_staff ||
        currentUser.data.user_type === USER_ACCESS.ADMIN
    : false;
};
